export default __webpack_public_path__ + "img/BB_RT_250MA_WF.f4fd1a071741f066efcefe3c60975b3a.jpg";